import React from 'react';
import IPhone from './IPhone';
import ScreenshotCarousel from './ScreenshotCarousel';
import HomeScreenUI from './HomeScreenUI';
import { APPS } from '../data/apps';
import { useReveal } from '../hooks/useReveal';
import { useTheme } from '../hooks/useTheme';
import { cx } from '../utils/cx';
import mixins from '../styles/mixins.module.css';
import styles from './HeroFan.module.css';

// Three-phone hero fan: the center phone shows a fake iOS home screen whose
// widget/ring/icon choreography plays once the fan scrolls into view (see
// HomeScreenUI); the side phones fan open ±11deg and run their own,
// deliberately out-of-sync screenshot carousels.
export default function HeroFan() {
  const [cadet, fridge] = APPS;
  const [ref, state] = useReveal();
  const { theme } = useTheme();
  const cadetHeroShots = theme === 'light' ? cadet.heroScreenshotsLight : cadet.heroScreenshotsDark;

  return (
    <div ref={ref} className={cx(styles.fan, state.in && styles.in)}>
      <div className={cx(mixins.halo, styles.halo)} />
      <IPhone className={cx(styles.phone, styles.left)}>
        <ScreenshotCarousel
          screenshots={cadetHeroShots}
          name={cadet.name}
          interval={3400}
          delay={1900}
        />
      </IPhone>
      <IPhone className={cx(styles.phone, styles.right)}>
        <ScreenshotCarousel
          screenshots={fridge.screenshots}
          name={fridge.name}
          interval={4300}
          delay={4600}
        />
      </IPhone>
      <IPhone className={cx(styles.phone, styles.mid)}>
        <HomeScreenUI playing={state.in} />
      </IPhone>
    </div>
  );
}
